import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FileUpload } from "../../../../components/ui/inputs";
import { BLOB_IMAGE_URL } from "../../../../config/appConfig";
import localization from "../../../../config/localization";
import { BlobContainerConsts } from "../../../../models/constants/blobContainerConsts";
import { UserBankAccountDetail } from "../../models/response/retrieveUserBankAccountResponse";
import { Button } from "../../../../components/ui/Button";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import userDeviceStore from "../../../../store/device.store";
import { DeviceType } from "../../../../models/constants/deviceType";
import { Header4 } from "../../../../components/ui/Headers";
import { Card, CardBody, CardHeader } from "../../../../components/ui/cards";

export function BankAccountDetail({
  bankAccount,
  handleBackButton,
}: {
  bankAccount: UserBankAccountDetail;
  handleBackButton: () => void;
}) {

  const deviceType = userDeviceStore((state) => state.deviceType);

  const content = (
    <div>
      <div>
        {deviceType !== DeviceType.Web ? (
          <div className="flex items-center gap-4">
            <Button
              type="button"
              className="flex h-9 w-9 items-center justify-center rounded-full bg-[#000000] border border-[#1F1F1F] text-white shadow-md"
              onClick={handleBackButton}
            >
              <FontAwesomeIcon icon={faChevronLeft} className="text-xs" />
            </Button>

            <span className="text-white text-xl font-bold">
              {localization.bank_account_detail}
            </span>
          </div>
        ) : (
          <Header4 className="text-white text-center mb-6">
            {localization.bank_account_detail}
          </Header4>
        )}

        <div className="border border-[#2a2a2a] rounded-md p-4 mt-4">
          <div className="grid grid-cols-2 gap-y-3 gap-x-4">
            <span className="text-[#D0D0D0]">{localization.bank_name1}</span>
            <span className="text-right break-all">{bankAccount.bankname}</span>

            <span className="text-[#D0D0D0]">
              {localization.beneficiary_name1}
            </span>
            <span className="text-right break-all">
              {bankAccount.beneficiaryname}
            </span>

            <span className="text-[#D0D0D0]">
              {localization.account_number1}
            </span>
            <span className="text-right break-all ">
              {bankAccount.accountnumber}
            </span>

            <span className="text-[#D0D0D0]">{localization.branch_name1}</span>
            <span className="text-right break-all">
              {bankAccount.branchname}
            </span>

            <span className="text-[#D0D0D0]">{localization.swift_ifsc}</span>
            <span className="text-right break-all ">{bankAccount.ifsc}</span>
          </div>

          <div className="w-full mt-4 relative">
            <FileUpload
              label={localization.uploaded_bank_document}
              labelClassName="text-[16px]"
              previewHeight={300}
              showBorder={false}
              canPreview={true}
              disabled={true}
              preview={`${BLOB_IMAGE_URL}${BlobContainerConsts.BankAttachment}/${bankAccount.bankstatementimage}`}
            />
          </div>
        </div>
      </div>
    </div>
  );

  return deviceType !== DeviceType.Web ? (
    content
  ) : (
    <Card >
      <CardHeader showBackButton={true} onBackButtonClick={handleBackButton} contentInline={true} />
      <CardBody showGradient={true}>
        <div className="w-full md:w-1/2 max-w-4xl mx-auto">{content}</div>
      </CardBody>
    </Card>
  );
}
